import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

import Button from 'web-components/Button';
import unsplash from 'web-assets/images/unsplash_modal.png';

export const Header = styled(Flex).attrs<{ isError?: boolean }>({
  align: 'center',
  justify: 'space-between',
  spacing: 8,
})`
  width: 100%;
  padding: 40px;
  position: relative;
  background: url(${unsplash}) center/cover no-repeat;

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: #679CFF;
    opacity: 0.8;
    z-index: 0;
  }
`;

export const Title = styled.div`
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  width: 100%;
  z-index: 9;

  img {
    height: 16px;
    display: block;
    margin-right: 5px;
  }
`;

export const Body = styled(Flex)`
  padding: 25px;
  padding-bottom: 35px;
  width: 100%;
`;

export const Close = styled(Button).attrs({
  appearance: 'link',
})`
  color: #000000;
  font-size: 24px;
  font-weight: normal;
  text-shadow: none;
  opacity: 0.7;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  position: absolute;
  top: 20px;
  right: 30px;
  z-index: 9;

  &:hover {
    opacity: 0.9;
  }
`;

export const Upgrade = styled(Button).attrs({
  type: 'button',
  appearance: 'success',
})`
  font-size: 16px;
  font-weight: bold;
  display: block;
  width: 100%;
  padding: 10px;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;

  ${props => props.isDisabled && `
    opacity: 0.55;
  `}
`;
